// import router from '@/app/router';
//
// const goBack = (route) => {
//   router.push({
//     name: 'dashboard',
//     query: route.query
//   });
// };

export default {
  default: {
    component: () => import(/* webpackChunkName: 'dashboard/dashboard' */ './WrhDashboard'),
    routes: [
      {
        path: '',
        name: 'wrh-dashboard',
        component: () => import(/* webpackChunkName: 'dashboard/dashboardMain' */ './components/DashboardMain')
      }
    ]
  }
};
